import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  RouterService,
  StateService,
  ToolService,
  User,
  UserRegistration,
  UserType,
} from '../../public-api';
import { ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  standalone: false,
})
export class UserFormComponent implements OnInit {
  constructor(
    public state: StateService,
    public tools: ToolService,
    private route: ActivatedRoute,
    private routerService: RouterService,
    public platform: Platform,
    private modalController: ModalController
  ) {}
  userTypes = (Object.values(UserType) as number[]).filter(
    (v) => typeof v === 'number' && v !== UserType.$3
  );

  subs: Subscription[] = [];
  @Input() userToEdit: User;
  user: UserRegistration = {};
  isEdit: boolean = false;
  showPassword: boolean = false;
  allUsers: User[] = [];

  ngOnInit() {
    this.subs.push(this.state.users$.subscribe((x) => (this.allUsers = x)));
    if (this.userToEdit != null) {
      this.isEdit = true;
      this.user.userName = this.userToEdit.userName;
      this.user.recievesFixedSalary = this.userToEdit.recievesFixedSalary;
      this.user.firstName = this.userToEdit.firstName;
      this.user.lastName = this.userToEdit.lastName;
      this.user.personalNumber = this.userToEdit.personalNumber;
      this.user.password = '';
      this.user.type = this.userToEdit.type;
      this.user.isDeactivated = this.userToEdit.isDeactivated;
      this.user.deactivatedUtc = this.userToEdit.deactivatedUtc;
      this.user.companies = this.userToEdit.companies;
      this.user.workingHoursPerDay = this.userToEdit.workingHoursPerDay;
    } else {
      this.user.firstName = '';
      this.user.lastName = '';
      this.user.workingHoursPerDay = 8;
      this.user.type = UserType.$0;
      this.generatePassword();
    }
  }

  getUserTypeLabel(type: UserType): string {
    switch (type) {
      case UserType.$0:
        return 'Mitarbeiter';
      case UserType.$1:
        return 'Büro';
      case UserType.$2:
        return 'Firmenadmin';
      default:
        return 'Unbekannt';
    }
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  registerUser() {
    this.tools
      .showConfirmAlert(
        false,
        'Das verursacht zusätzliche monatliche Kosten',
        'Mitarbeiter anlegen?'
      )
      .then((x) => {
        if (x) {
          this.state.createUser(
            this.user.firstName,
            this.user.lastName,
            this.user.password,
            this.user.personalNumber,
            this.user.type,
            this.user.recievesFixedSalary
          );
          this.modalController.dismiss();
        }
      });
  }

  userExists() {
    if (
      this.allUsers.find(
        (x) =>
          x.firstName.toLowerCase() ==
            this.user.firstName.trim().toLowerCase() &&
          x.lastName.toLowerCase() == this.user.lastName.toLowerCase()
      ) != null
    )
      return true;
    return false;
  }

  updateUser() {
    this.state.updateUser(this.user);
    this.modalController.dismiss();
  }

  deleteUser() {
    this.tools
      .showConfirmAlert(
        true,
        'den Mitarbeiter ' + this.user.firstName + ' ' + this.user.lastName
      )
      .then((x) => {
        if (x) this.state.deleteUser(this.user.userName);
        this.modalController.dismiss();
      });
  }

  deactivateUser() {
    this.tools
      .showConfirmAlert(
        false,
        'Danach kann sich der Mitarbeiter nicht mehr anmelden',
        'Mitarbeiter deaktivieren?'
      )
      .then((x) => {
        if (x) this.state.deactivateUser(this.user.userName);
        this.modalController.dismiss();
      });
  }

  activateUser() {
    this.tools
      .showConfirmAlert(
        false,
        'Das verursacht zusätzliche monatliche Kosten',
        'Mitarbeiter aktivieren?'
      )
      .then((x) => {
        if (x) this.state.activateUser(this.user.userName);
        this.modalController.dismiss();
      });
  }

  hasInvalidFields(): boolean {
    if (
      this.user.firstName == '' ||
      this.user.lastName == '' ||
      (!this.isValidPw(this.user.password) && !this.isEdit) ||
      (this.isEdit && this.showPassword && !this.isValidPw(this.user.password))
    ) {
      return true;
    } else {
      return false;
    }
  }

  generatePassword(length: number = 12): void {
    this.showPassword = true;
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const numberChars = '0123456789';
    this.user.password =
      Array.from({ length }, () =>
        chars.charAt(Math.floor(Math.random() * chars.length))
      ).join('') +
      numberChars.charAt(Math.floor(Math.random() * numberChars.length));
  }

  isValidPw(input: string): boolean {
    if (input.length < 12) {
      return false;
    }
    const hasLetter = /[A-Za-z]/.test(input);
    const hasNumber = /\d/.test(input);
    return hasLetter && hasNumber;
  }
}
